export const insights = [
  {
    slug: 'hidden-cost-of-bad-data',
    title: 'The Hidden Cost of Bad Data',
    short: 'Why data quality is your biggest ROI lever.',
    date: 'Dec 2025',
    category: 'Data Strategy',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80',
    body:
      'Poor data quality silently bleeds enterprises of millions every year — through bad forecasts, broken pipelines, and decisions made on stale numbers. In this piece we share the framework Fortune 500 leaders use to achieve 99.5% data accuracy and turn quality from a cost center into an ROI multiplier.',
  },
  {
    slug: 'dashboards-to-decisions',
    title: 'From Dashboards to Decisions',
    short: 'Building a true data-driven culture.',
    date: 'Nov 2025',
    category: 'Leadership',
    image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200&q=80',
    body:
      '83% of companies have dashboards. Only 12% are truly data-driven. We break down what separates leaders from laggards — and the operating model that turns insights into consistent decisions.',
  },
  {
    slug: 'why-ml-projects-fail',
    title: 'Why Most ML Projects Fail',
    short: '5 honest reasons — and how to avoid them.',
    date: 'Nov 2025',
    category: 'AI / ML',
    image: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=1200&q=80',
    body:
      '87% of ML projects never make it to production. From data leakage to missing MLOps to stakeholder drift, here are the patterns we see most often — and the playbook to ship models that actually deliver value.',
  },
  {
    slug: 'fp-and-a-ai-transformation',
    title: 'How AI is Rewriting FP&A',
    short: 'From spreadsheets to autonomous forecasting.',
    date: 'Oct 2025',
    category: 'Finance',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1200&q=80',
    body:
      'Finance teams are moving from monthly Excel cycles to continuous, AI-assisted planning. We share the operating model that makes the shift stick and the metrics that prove it works.',
  },
];